var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9493 8.50589H20.0973V8.46199H10.5775V12.693H16.5554C15.6833 15.156 13.3398 16.924 10.5775 16.924C7.07265 16.924 4.231 14.0823 4.231 10.5775C4.231 7.07264 7.07265 4.231 10.5775 4.231C12.1953 4.231 13.6672 4.84132 14.7879 5.83824L17.7797 2.8464C15.8906 1.08578 13.3636 0 10.5775 0C4.73608 0 0 4.73607 0 10.5775C0 16.4189 4.73608 21.155 10.5775 21.155C16.4189 21.155 21.155 16.4189 21.155 10.5775C21.155 9.86827 21.082 9.17597 20.9493 8.50589Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.21875 5.6542L4.69398 8.20284C5.63432 5.87474 7.91165 4.231 10.5766 4.231C12.1945 4.231 13.6663 4.84132 14.787 5.83824L17.7789 2.8464C15.8897 1.08578 13.3628 0 10.5766 0C6.51384 0 2.99048 2.29373 1.21875 5.6542Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5787 21.1541C13.3109 21.1541 15.7934 20.1085 17.6704 18.4082L14.3967 15.638C13.299 16.4727 11.9577 16.9242 10.5787 16.9231C7.82752 16.9231 5.49148 15.1689 4.61143 12.7207L1.16211 15.3783C2.91268 18.8038 6.46778 21.1541 10.5787 21.1541Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9499 8.50483H20.0979V8.46094H10.5781V12.6919H16.556C16.1388 13.8641 15.3874 14.8884 14.3945 15.6383L14.3961 15.6372L17.6698 18.4075C17.4382 18.618 21.1556 15.8652 21.1556 10.5764C21.1556 9.86721 21.0826 9.17492 20.9499 8.50483Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAvatar);
export default __webpack_public_path__ + "static/media/googleAvatar.c111bb47fe7e60642d80b3254a0bccdd.svg";
export { ForwardRef as ReactComponent };